import React, { Fragment } from "react";

import {
  PDFViewer,
  PDFDownloadLink,
  Document,
  Page,
  Text,
  View,
  Image,
  Link,
} from "@react-pdf/renderer";

import styles from "./styles";

import CONFIG from "../../../config";
const { logo, logo_pdf, footer_pdf } = CONFIG.setup.assets;
const currentTime = new Date();
const year = currentTime.getFullYear();

const footer = ({ order }) => {
  const { formattedSettlementAccount } = order;
  return (
    <Fragment>
      <View style={[styles.container, styles.otherWrapper]}>
        <View style={styles.otherContainer}>
          <View style={[styles.line, { marginTop: 5, marginBottom: 5 }]}></View>
          <View style={styles.columnDirection}>
            <Text style={styles.DefaultName}>
              Please include the order number with your payment and direct
              credit funds into:
            </Text>
            <Text style={styles.DefaultNameLarge}>
              WESTFIELD GIFT CARD ACCOUNT{" "}
            </Text>
            <Text style={styles.DefaultNameLargeBottom}>
              {formattedSettlementAccount &&
              formattedSettlementAccount.length !== 0
                ? formattedSettlementAccount
                : "03-0104-0948859-19"}
            </Text>
            <Text style={styles.DefaultName}>
              This quotation is valid fo 30 days from the date stated above.
            </Text>
          </View>
        </View>
      </View>

      <View wrap={false} style={[styles.container, styles.footerWrapper]}>
        <View style={styles.footerContainer}>
          <View style={[styles.footerMainBg]}>
            <Image style={styles.lineFooter} src={footer_pdf} />
          </View>

          <View style={[styles.footerMain]}>
            <View style={[styles.footerContentContainer]}>
              <View style={styles.footerContentLeft}>
                <Text style={[styles.footerContentText, styles.defaultBold]}>
                  GIFT CARDS
                </Text>
                <Text style={styles.footerContentText}>
                  <Text style={styles.defaultBold}>Call</Text>{" "}
                  {order.enrolmentTraderPhone1} - 9am - 5pm UTC, Business days
                </Text>
                <Text style={styles.footerContentText}>
                  <Text style={styles.defaultBold}>Email</Text>{" "}
                  {/* {order.enrolmentTraderEmailAddress} */}
                  giftcardsnzcorporate@scentregroup.com
                </Text>
              </View>
              <View style={styles.footerContentRight}>
                <View style={styles.textContainer}>
                  <Image style={styles.logoFooter} src={logo_pdf} />
                </View>
              </View>
            </View>
            <View style={[styles.footerContentContainer]}>
              <View style={styles.footerContentFull}>
                <Text style={styles.footerContentLinks}>
                  <Link src="https://giftcards.westfield.co.nz/page/contact">
                    Contact Us{" "}
                  </Link>
                  <Text> </Text>
                  <Link src="https://www.westfield.co.nz/privacy-policy">
                    Privacy Policy{" "}
                  </Link>
                  <Text> </Text>
                  <Link src="https://www.westfield.co.nz/terms-and-conditions">
                    Product Terms & Condition
                  </Link>
                  <Text> </Text>
                  <Link src="http://www.scentregroup.com/">
                    @ {year} Scentre Group
                  </Link>
                </Text>
              </View>
            </View>
          </View>
        </View>
      </View>
    </Fragment>
  );
};

export default footer;
